'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral([''], ['']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getScreenSize = require('../../helpers/getScreenSize');

var _getScreenSize2 = _interopRequireDefault(_getScreenSize);

var _isMobile = require('../../helpers/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

var _isTablet = require('../../helpers/isTablet');

var _isTablet2 = _interopRequireDefault(_isTablet);

var _isDesktop = require('../../helpers/isDesktop');

var _isDesktop2 = _interopRequireDefault(_isDesktop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ScreenComponent = _styledComponents2.default.div(_templateObject);

var Screen = function (_React$Component) {
	_inherits(Screen, _React$Component);

	function Screen(props) {
		_classCallCheck(this, Screen);

		var _this = _possibleConstructorReturn(this, (Screen.__proto__ || Object.getPrototypeOf(Screen)).call(this, props));

		_this.getContentHeight = function () {
			var body = document.body;
			var html = document.documentElement;

			var height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

			return height;
		};

		_this.getContentWidth = function () {
			var body = document.body;
			var html = document.documentElement;

			var width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);

			return width;
		};

		_this.setScreenProperties = function () {
			_this.setState({ screenSize: (0, _getScreenSize2.default)() });
			var screen = {
				clientHeight: _this.getContentHeight(),
				viewHeight: window.innerHeight,
				clientWidth: _this.getContentWidth(),
				viewWidth: window.innerWidth,
				size: (0, _getScreenSize2.default)(),
				isMobile: (0, _isMobile2.default)((0, _getScreenSize2.default)()),
				isTablet: (0, _isTablet2.default)((0, _getScreenSize2.default)()),
				isDesktop: (0, _isDesktop2.default)((0, _getScreenSize2.default)())
			};
			_this.setState({ screen: screen });
			if (_this.props.changeEvent) {
				_this.props.changeEvent(screen);
			}
		};

		_this.state = {
			screenSize: '',
			screen: {
				size: '',
				clientHeight: '',
				viewHeight: '',
				clientWidth: '',
				viewWidth: '',
				isMobile: false,
				isTablet: false,
				isDesktop: false
			}
		};
		return _this;
	}

	_createClass(Screen, [{
		key: 'getChildContext',
		value: function getChildContext() {
			return {
				screenSize: this.state.screenSize,
				screen: this.state.screen
			};
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.setScreenProperties();
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.setScreenProperties();

			window.addEventListener('resize', this.setScreenProperties);
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			if (this.state.screen.clientHeight !== this.getContentHeight()) {
				this.setScreenProperties();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			window.removeEventListener('resize', this.setScreenProperties);
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				ScreenComponent,
				null,
				this.props.children
			);
		}
	}]);

	return Screen;
}(_react2.default.Component);

Screen.childContextTypes = {
	screenSize: _propTypes2.default.string,
	screen: _propTypes2.default.object
};

exports.default = Screen;